import { useAppSelector } from 'state/hooks';
import { selectSpecialEventDates } from 'state/userAdminSlices';
import { getUsedQuotaFromRequests } from 'state/utils';

import { useSubscription } from 'features/common/hooks/useSubscription';

export const useDatesQuota = (subscriptionId?: string, projectId?: string) => {
  const { subscription, project_data } = useSubscription(
    subscriptionId,
    projectId,
  );
  const uprDates = useAppSelector(selectSpecialEventDates);
  const specialDates = project_data?.special_date_requests ?? uprDates;
  const usedQuota = getUsedQuotaFromRequests(specialDates);

  const allQuota: number =
    project_data?.special_dates_quota ??
    subscription?.template?.special_dates_quota;
  const freeQuota: number = allQuota - usedQuota;
  return {
    freeQuota,
    usedQuota,
    allQuota,
  };
};
